unable to read source [project]/woocommerce-products/node_modules/performance-now/lib/..src/performance-now.coffee